import React from "react";
import CustomDrawer from "components/shared-components/CustomDrawer";
import Scrollbars from "react-custom-scrollbars-2";

const MediaGroupViewer = ({
  open,
  onClose,
  messages = [],
  isMobile = false,
  renderMedia,
}) => (
  <CustomDrawer
    title={`${messages.length} items`}
    open={open}
    onClose={onClose}
    destroyOnClose
    width={!isMobile ? "50vw" : undefined}
    styles={{
      body: { padding: isMobile ? "12px 16px" : "16px" },
    }}
  >
    <Scrollbars
      autoHide
      style={{ height: isMobile ? "calc(50vh - 90px)" : "calc(100vh - 120px)" }}
    >
      <div
        style={
          isMobile
            ? {
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 8,
            }
            : {
              columnWidth: "140px",
              columnGap: 8,
              width: "100%",
            }
        }
      >
        {messages.map((message, index) => {
          const url = message.from === "opposite" ? message.media_url : message.text;
          const isDownloaded = !!url;
          return (
            <div
              key={message.id || message.message_id || `viewer-${index}`}
              style={{
                position: "relative",
                borderRadius: 8,
                overflow: "hidden",
                ...(isMobile
                  ? {
                    background: "#f5f5f5",
                    aspectRatio: "1/1",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }
                  : {
                    display: "block",
                    marginBottom: 8,
                    breakInside: "avoid",
                    ...(isDownloaded
                      ? {
                        background: "transparent",
                      }
                      : {
                        background: "#f5f5f5",
                        aspectRatio: "1/1",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }),
                  }),
              }}
            >
              {renderMedia(message)}
            </div>
          );
        })}
      </div>
    </Scrollbars>
  </CustomDrawer>
);

export default MediaGroupViewer;
